export default {
      id: "neuro-usage",
      viewBox: "0 0 100 20",
      url: "assets/" + "sprite.svg#neuro-usage",
      toString: function () {
        return this.url;
      }
    }